import { useQueryParams } from '~/hooks/use-query-params/useQueryParams';
import { queryKeys, queryValues } from '~/routes/query-params';

export const useBrandAndProductDrawer = () => {
  const { deleteQueryParam, setQueryParams, params } = useQueryParams();
  const product = params[queryKeys.product];
  const isDrawerOpen =
    params[queryKeys.activeDrawer] === queryValues.brandAndProductDrawer;

  const openDrawer = (product: string) =>
    setQueryParams({
      [queryKeys.activeDrawer]: queryValues.brandAndProductDrawer,
      [queryKeys.product]: product,
    });

  const closeDrawer = () =>
    deleteQueryParam([queryKeys.activeDrawer, queryKeys.product]);

  return {
    closeDrawer,
    openDrawer,
    isDrawerOpen,
    product,
  };
};
